import getApiClient from 'src/utils/getApiClient'
import type {
  DoctorTelemedSlotsRequest,
  DoctorTelemedSlotsResponse,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/api/apiDoctorTelemedSlots.types'

const apiClient = getApiClient()

const apiDoctorTelemedSlots = {
  post(payload: DoctorTelemedSlotsRequest) {
    return apiClient.post<DoctorTelemedSlotsResponse>(
      '/ajax/schedule/slots_bulk/telemed/',
      payload,
    )
  },
}

export default apiDoctorTelemedSlots
